import MoveAndRotate from "./moveAndRotate";

class MoveModel extends MoveAndRotate {
    animateMovement;
    animateTime;

    constructor(props) {
        super(props);
        this.animateMovement = props.animateMovement;
        this.animateTime = props.animateTime;
    }

    getComposedMatrix(model) {
        let composedMatrix = new THREE.Matrix4().compose(this.position, this.quaternion, this.scale);

        if (this.transitionValues) {
            composedMatrix.premultiply(model.matrix.clone());
        }

        return composedMatrix;
    }

    async stop(training) {
        const resourceId = training.resources[this.model.id].resourceId;
        CADModelTransformationAnimationManager.completeAndRemoveCurrentAnimationOfThisModel(resourceId);
    }

    async execute({training}) {
        const resourceId = training.resources[this.model.id].resourceId ||
            (training.resources[this.model.id]?.type === ResourceTypeEnum.HELPER_OBJECT && training.resources[this.model.id]?.id);
        const model = getModelObject(resourceId);
        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.MODEL, model.modelId);
        const array = this.getComposedMatrix(model).toArray();

        if (this.animateMovement === undefined || this.animateMovement === true) {
            if (!this.animateTime) {
                this.animateTime = 2000;
            }
            CADModelTransformationAnimationManager.transformModelWithAnimation(resourceId, array, undefined, this.animateTime);
        } else {
            CADModelTransformationAnimationManager.transformModelWithoutAnimation(resourceId, array);
        }
    }
}

export default MoveModel;
